<template>
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        v-if="$route.query.operateType !== '查看'"
        :disabled="tableData.length >= 15"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <el-table-column label="市场实销" align="center">
        <el-table-column
          prop="carModel"
          label="车型"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'carModel' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.carModel"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.carModel }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="2024年" align="center">
        <el-table-column
          prop="oneShixiao"
          label="1月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'oneShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.oneShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.oneShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="twoShixiao"
          label="2月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'twoShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.twoShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.twoShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="threeShixiao"
          label="3月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'threeShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.threeShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.threeShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fourShixiao"
          label="4月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'fourShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.fourShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.fourShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fiveShixiao"
          label="5月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'fiveShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.fiveShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.fiveShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sixShixiao"
          label="6月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'sixShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.sixShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.sixShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sevenShixiao"
          label="7月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'sevenShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.sevenShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.sevenShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="eightShixiao"
          label="8月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'eightShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.eightShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.eightShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="nineShixiao"
          label="9月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'nineShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.nineShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.nineShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tenShixiao"
          label="10月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'tenShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.tenShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.tenShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="elevenShixiao"
          label="11月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'elevenShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.elevenShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.elevenShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="twelveShixiao"
          label="12月"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="editField === 'twelveShixiao' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.twelveShixiao"
              class="number_input"
              :controls="false"
              :precision="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.twelveShixiao }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="合计"
          min-width="90px"
          align="center"
          class-name="total_column"
        >
          <template slot-scope="scope">
            {{ getTotal(scope.row) }}
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        v-if="$route.query.operateType !== '查看'"
        label="操作"
        align="center"
        width="90px"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateAllBrandCarModelApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data) {
      this.tableData = data || [];
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        carModel: "",
        years: "2024"
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 合计
    getTotal(data) {
      return (
        (data.oneShixiao ? data.oneShixiao : 0) +
        (data.twoShixiao ? data.twoShixiao : 0) +
        (data.threeShixiao ? data.threeShixiao : 0) +
        (data.fourShixiao ? data.fourShixiao : 0) +
        (data.fiveShixiao ? data.fiveShixiao : 0) +
        (data.sixShixiao ? data.sixShixiao : 0) +
        (data.sevenShixiao ? data.sevenShixiao : 0) +
        (data.eightShixiao ? data.eightShixiao : 0) +
        (data.nineShixiao ? data.nineShixiao : 0) +
        (data.tenShixiao ? data.tenShixiao : 0) +
        (data.elevenShixiao ? data.elevenShixiao : 0) +
        (data.twelveShixiao ? data.twelveShixiao : 0)
      );
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(params) {
      try {
        const submitData = {
          ...params,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateAllBrandCarModelApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
